<template>
  <div class="footer-container">
    <p>Copyright © 2018-2021 shiguang All Rights Reserved.</p>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.footer-container {
  font-size: 12px;
  line-height: 40px;
  text-align: center;
  color: #909399;
  background-color: #f4f4f4;
}
</style>
